import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import JobCustomAddress from './customAddress';
import JobCustomDateTime from './customDateTime';

class JobEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAttachmentInput: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.ourLocation.fetchList());

    const billingAccountId = this.props.form.base_task_attributes.billing_account_id;
    if (billingAccountId) {
      this.props.dispatch(ReduxActions.billingAccount.fetch(billingAccountId));
    }
  }

  _getDefaultAddressList = data => data.map(address => this._getDefaultAddress(address));

  _getDefaultAddress = (address = {}) => ({
    name: address.name || null,
    line_1: address.line_1 || null,
    line_2: address.line_2 || null,
    city: address.city || null,
    zip: address.zip || null,
    country: address.country || null,
  });

  _isPointToPoint = () => {
    const { data } = this.props;
    const p2p = data.job_type === 'p2p';

    return p2p || (data.job_type === 'delivery' && data.tags && data.tags.filter(tag => tag.name === 'Point-to-Point').length > 0);
  }

  _getAddresses() {
    const billingAccountId = this.props.form.base_task_attributes.billing_account_id;
    if (billingAccountId && this.props.billingAccounts[billingAccountId]) {
      return this.props.billingAccounts[billingAccountId].addresses
        .concat(this._getDefaultAddressList(this.props.optionAddresses))
        .concat(this.props.ourLocations);
    }

    return this._getDefaultAddressList(this.props.optionAddresses).concat(this.props.ourLocations);
  }

  _getAccountOptions() {
    const { customer } = this.props;
    if (customer && !Utils.Helper.isNullOrUndefined(customer.billing_accounts)) {
      return customer.billing_accounts.map(account => ({
        value: account.id,
        text: account.name,
      }));
    }
    return [];
  }

  _renderAdditionalInfo() {
    if (!this.props.myjobsSetting.show_additional_info) {
      return false;
    }

    return (
      <Components.Form.ExpandableContainer
        parent={(
          <Components.Form.Block iconClassName="versa-subject" iconText="" level={0}>
            {this.props.strings.Job.form.additionalInfo.title}
          </Components.Form.Block>
        )}
      >
        <Components.Form.Divider />

        {this.props.myjobsSetting.show_note ? (
          <Components.Form.Block
            iconClassName="versa-note"
            iconText=""
            isInputIcon
            level={1}
          >
            <Components.Input.Textarea
              onChange={value => this.props.onFormChange('remarks', value)}
              placeholder={this.props.strings.Job.form.additionalInfo.remarksHint}
              value={this.props.form.remarks}
            />
          </Components.Form.Block>
        ) : false}

        {this.props.myjobsSetting.show_tags ? (
          <Components.Form.Block iconClassName="versa-tags" iconText="" isInputIcon level={1}>
            <Components.Input.Tag
              error={this.props.error.tag_list}
              onChange={value => this.props.onFormChange('tag_list', value)}
              options={this.props.constant.jobs.tags.map(tag => ({
                text: tag,
                value: tag,
              }))}
              placeholder={this.props.strings.Job.form.additionalInfo.tagHint}
              value={this.props.form.tag_list}
            />
          </Components.Form.Block>
        ) : false}

        <Components.Form.Block iconClassName="versa-attachment" iconText="" isInputIcon level={1}>
          {Utils.UserAgentDetector.isMobileOrTablet() ? (
            <Components.Form.MobileAttachmentInput
              apiUrl={process.env.apiUrl}
              editable
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onChange={value => this.props.onFormChange('attachments_attributes', value)}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={this.props.form.attachments_attributes}
            />
          ) : (
            <Components.Form.AttachmentInput
              apiUrl={process.env.apiUrl}
              editable
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onChange={value => this.props.onFormChange('attachments_attributes', value)}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={this.props.form.attachments_attributes}
            />
          )}
        </Components.Form.Block>
      </Components.Form.ExpandableContainer>
    );
  }

  render() {
    const stringsPickupInfo = this.props.strings.Job.form.pickupInfo;
    const error = this.props.error.base_task || {};

    return (
      <div>
        <Components.Form.MobileMainHeader
          iconClassName={this.props.data.job_type === 'pickup' ? 'versa-base-pickup'
            : 'versa-base-delivery'}
          iconText=""
          text={this.props.data.job_type === 'pickup' ? stringsPickupInfo.deliveryTo
            : stringsPickupInfo.pickupFrom}
        />
        <Components.Form.Block level={1}>
          {this.props.data.customer ? this.props.data.customer.name : this.props.customer.name}
          <br />
          {this.props.data.guid}
        </Components.Form.Block>

        {this._isPointToPoint() ? (
          <React.Fragment>
            <Components.Form.Divider />
            <Components.Form.InputGroup>
              <Components.Form.Block
                iconClassName="versa-person"
                isInputIcon
                level={0}
              >
                <Components.Input.Select
                  error={error.billing_account}
                  onChange={v => this.props.onFormChange('base_task_attributes.billing_account_id', v)}
                  options={this._getAccountOptions()}
                  placeholder={this.props.strings.Job.form.pickupInfo.accountHint}
                  value={this.props.form.base_task_attributes.billing_account_id
                    || (this.props.form.base_task_attributes.billing_account_attributes
                      || {}).name}
                />
              </Components.Form.Block>
            </Components.Form.InputGroup>
          </React.Fragment>
        ) : null}

        <Components.Form.Divider />

        <Components.Form.InputGroup>
          <Components.Form.Block
            iconClassName="versa-call"
            isInputIcon
            level={0}
          >
            <Components.Input.Textbox
              error={this.props.error.base_task && this.props.error.base_task.address
                && this.props.error.base_task.address.contact_person}
              onChange={value => this.props.onFormChange('base_task_attributes.address_attributes.contact_person', value)}
              placeholder={this.props.strings.Job.form.additionalInfo.contactPersonHint}
              value={this.props.form.base_task_attributes.address_attributes.contact_person}
            />
          </Components.Form.Block>
          <Components.Form.Block
            iconClassName=""
            iconText=""
            isInputIcon
            level={0}
          >
            <Components.Input.Textbox
              error={this.props.error.base_task && this.props.error.base_task.address
                && this.props.error.base_task.address.contact_number}
              onChange={value => this.props.onFormChange('base_task_attributes.address_attributes.contact_number', value)}
              placeholder={this.props.strings.Job.form.additionalInfo.contactNumberHint}
              value={this.props.form.base_task_attributes.address_attributes.contact_number}
            />
          </Components.Form.Block>
          <Components.Form.Block
            iconClassName=""
            iconText=""
            isInputIcon
            level={0}
          >
            <Components.Input.Textbox
              error={this.props.error.base_task && this.props.error.base_task.address
                && this.props.error.base_task.address.email}
              onChange={value => this.props.onFormChange('base_task_attributes.address_attributes.email', value)}
              placeholder={this.props.strings.Job.form.additionalInfo.contactEmailHint}
              value={this.props.form.base_task_attributes.address_attributes.email}
            />
          </Components.Form.Block>
        </Components.Form.InputGroup>

        <Components.Form.Divider />

        <JobCustomAddress
          addressList={this._getAddresses()}
          error={error.address}
          iconClassName="versa-marker-plain"
          id="vf-job__edit-form__left-panel__main-info__address"
          onChange={(value, shouldChange) => this.props.onFormChange(
            'base_task_attributes.address_attributes', value, undefined, undefined, shouldChange,
          )}
          value={this.props.form.base_task_attributes.address_attributes}
        />

        <Components.Form.Divider />

        <JobCustomDateTime
          error={error}
          id="vf-job__edit-form__left-panel__main-info"
          onChange={value => this.props.onFormChange('base_task_attributes', value)}
          shouldFilterTimeWindows={false}
          value={this.props.form.base_task_attributes}
        />

        <Components.Form.Divider size="LARGE" />

        {/* Additional Info */}

        {this._renderAdditionalInfo()}
        <Components.Form.Divider />
      </div>
    );
  }
}

JobEdit.propTypes = {
  billingAccounts: PropTypes.objectOf({
    addresses: PropTypes.arrayOf(PropTypes.shape()),
  }),
  constant: PropTypes.shape({
    jobs: PropTypes.shape({
      tags: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  customer: PropTypes.shape({
    billing_accounts: PropTypes.arrayOf(PropTypes.shape({
      addresses: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string,
      })),
      id: PropTypes.number,
    })),
    name: PropTypes.string,
  }).isRequired,
  data: PropTypes.shape({
    customer: PropTypes.shape({
      name: PropTypes.string,
    }),
    guid: PropTypes.string,
    job_type: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.shape({
    base_task: PropTypes.shape({
      address: PropTypes.shape({
        contact_person: PropTypes.string,
        contact_number: PropTypes.string,
        email: PropTypes.string,
      }),
      billing_account: PropTypes.string,
    }),
    time_from: PropTypes.string,
    time_to: PropTypes.string,
    time_type: PropTypes.string,
    tag_list: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  form: PropTypes.shape({
    base_task_attributes: PropTypes.shape({
      address_attributes: PropTypes.shape(),
      billing_account_id: PropTypes.number,
      billing_account_attributes: PropTypes.shape(),
    }),
    job_type: PropTypes.string,
    remarks: PropTypes.string,
    tag_list: PropTypes.arrayOf(PropTypes.string),
    attachments_attributes: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  myjobsSetting: PropTypes.shape({
    show_additional_info: PropTypes.bool,
    show_note: PropTypes.bool,
    show_tags: PropTypes.bool,
  }).isRequired,
  onFormChange: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
  })),
  ourLocations: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        additionalInfo: PropTypes.shape({
          title: PropTypes.string,
          remarksHint: PropTypes.string,
          tagHint: PropTypes.string,
          contactPersonHint: PropTypes.string,
          contactNumberHint: PropTypes.string,
          contactEmailHint: PropTypes.string,
        }),
        pickupInfo: PropTypes.shape({
          accountHint: PropTypes.string,
          deliveryTo: PropTypes.string,
          pickupFrom: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobEdit.defaultProps = {
  optionAddresses: [],
  billingAccounts: [],
};

const mapStateToProps = (state) => {
  const { billingAccount, profile, ourLocation } = state;
  return {
    billingAccounts: billingAccount.billingAccounts,
    myjobsSetting: (profile.profile || {}).myjobs_setting,
    ourLocations: ourLocation.ourLocationIds.map(id => ourLocation.ourLocations[id]) || [],
  };
};

export default connect(mapStateToProps)(translate('')(JobEdit));
